import LoginForm from "@/components/auth/LoginForm"
import MfaForm from "@/components/auth/MfaForm"
import useAuth from "@/components/auth/useAuth"
import ReportIssueButton from "@/components/util/ReportIssueButton"
import {
  Card,
  CardContent,
  Container,
  Grid,
  makeStyles
} from "@material-ui/core"
import Cookies from "js-cookie"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { Link, Redirect } from "react-router-dom"

const useStyles = makeStyles(theme => ({
  card: {
    marginTop: theme.spacing(16)
  },
  cardContent: {
    margin: theme.spacing(3)
  },
  forgot: {
    textDecoration: "none",
    paddingLeft: theme.spacing(6),
    paddingTop: theme.spacing(2)
  },
  floatingIcon: {
    position: "fixed",
    bottom: theme.spacing(4),
    right: theme.spacing(4),
    zIndex: 1000,
    backgroundColor: "#3c4dac",
    borderRadius: "50%",
    width: 56,
    height: 56,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    boxShadow: theme.shadows[4],
    cursor: "pointer",
    transition:
      "transform 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease",
    "&:hover": {
      backgroundColor: "#2c3d8a",
      transform: "scale(1.08)",
      boxShadow: theme.shadows[6]
    },
    "&:active": {
      transform: "scale(0.95)",
      boxShadow: theme.shadows[2]
    }
  }
}))

export default function Login() {
  const classes = useStyles()
  const { token, login_with_token } = useAuth()
  const { t } = useTranslation()
  const [view, setView] = useState<"LOGIN" | "MFA">("LOGIN")
  const [mfaMethod, setMfaMethod] = useState<string>("email")

  //okta callback-hell bridge
  let cookie_token = Cookies.get("user_token")
  if (cookie_token) {
    login_with_token(token ?? cookie_token)

    // must be exact match, otherwise user will stay "logged on" till session expires
    //note: this will not work on localhost
    Cookies.remove("user_token", { path: "/", domain: ".visual-alpha.com" })
    // enable on localhost to test if needed
    // Cookies.remove( "user_token", { path: '/', domain: 'localhost' } );
    return <Redirect to="/" />
  }
  // user authenticated
  if (token) return <Redirect to="/" />

  // regular login -> these two should be merged
  //    okta redirect happens inside here on response

  const handleMfaRequired = (data: any) => {
    setMfaMethod(data.method)
    setView("MFA")
  }

  const handleCancelMfa = () => {
    setView("LOGIN")
  }

  return (
    <>
      <Container maxWidth="xs">
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            {view === "LOGIN" ? (
              <LoginForm onMfaRequired={handleMfaRequired} />
            ) : (
              <MfaForm method={mfaMethod} onCancel={handleCancelMfa} />
            )}
          </CardContent>
        </Card>
        {view === "LOGIN" ? (
          <Grid container>
            <Link to="/forgotpassword" className={classes.forgot}>
              {t("Forgot your password?")}
            </Link>
          </Grid>
        ) : (
          <></>
        )}
      </Container>
      <div className={classes.floatingIcon}>
        <ReportIssueButton label={false} style={{ color: "#fff" }} />
      </div>
    </>
  )
}
